import { createContext } from "react";

const myContext = createContext({
    user_authorizations: {}
});

export const ContextProvider = myContext.Provider;
export const ContextConsumer = myContext.Consumer;